// import { useState } from "react";
// import { useHistory, Link } from "react-router-dom";

// const NewArrivals = () => {
//   const [selectedType, setSelectedType] = useState("Chats");
//   const history = useHistory();

//   const promoIds = [1, 2];
//   const categoriess = ["Chats", "Chiens", "Jouets", "More"];

//   const handleCategoryClick = (cat) => {
//     if (cat === "More") {
//       history.push("/shop");
//     } else {
//       setSelectedType(cat);
//     }
//   };
//   const products = [
//     { id: 1, name: "Brit Care Sans Céréales Pour chats", category: "Alimentation", subcategory: "Croquettes", priceRange: "15,300DT – 148,500DT", image: "img/product/brit-care-chat.jpg", promo: true },
//     { id: 2, name: "Brit Premium By Nature", category: "Alimentation", subcategory: "Croquettes", priceRange: "10,800DT – 139,500DT", image: "img/product/brit-premium.jpg", promo: true },
//     { id: 3, name: "Carnilove Chat", category: "Alimentation", subcategory: "Croquette", priceRange: "71,000DT", image: "img/product/carnilove-chat.jpeg" },
//     { id: 4, name: "Carnilove TRUE FRESH", category: "Alimentation", subcategory: "Croquette", priceRange: "73,500DT", image: "img/product/carnilove-truefresh.jpg" },
//     { id: 5, name: "COTAGRO CHAT DAILY MENU 20KG", category: "Alimentation", subcategory: "Croquette", priceRange: "52,000DT – 207,000DT", image: "img/product/cotagro-dailymenu.jpg" },
//     { id: 6, name: "COTAGRO CHIEN", category: "Alimentation", subcategory: "Croquette", priceRange: "198,000DT – 210,000DT", image: "img/product/cotagroadult.jpg" },
//     { id: 7, name: "DOG VET SOLUTION", category: "Alimentation", subcategory: "Croquette", priceRange: "93,000DT – 395,000DT", image: "img/product/dogvet.png" },
//     { id: 8, name: "Royal Canin Maxi", category: "Alimentation", subcategory: "Croquette", priceRange: "135,000DT – 355,000DT", image: "img/product/maxi.jpg" },
//     { id: 9, name: "Royal Canin Medium", category: "Alimentation", subcategory: "Croquette", priceRange: "140,000DT – 355,000DT", image: "img/product/medium.jpg" },
//     { id: 10, name: "Royal Canin Mini", category: "Alimentation", subcategory: "Croquette", priceRange: "95,000DT – 100,000DT", image: "img/product/miniiroyale.jpg" },
//     { id: 13, name: "VET BARQ. CAT DERMATOSIS 100 G", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "5,500DT", image: "img/product/vet-barq.jpg" },
//     { id: 14, name: "BARQUETTE ECO DIANA", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "2,700DT", image: "img/product/eco-diana.jpg" },
//     { id: 15, name: "BARQUETTE PLAISIR", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "3,000DT – 3,300DT", image: "img/product/plaisir-barquette.jpg" },
//     { id: 16, name: "Boite Kippy Chat 400 GR", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "7,000DT – 7,800DT", image: "img/product/kippy-chat.jpg" , promo: true },
//     { id: 17, name: "PLAISIR CHEF CHAT 190G", category: "Alimentation", subcategory: "Boîtes & Pochon & Barquette", priceRange: "7,800DT", image: "img/product/plaisir-casserole.png" },
//     { id: 18, name: "Jerky Time Mini Os", category: "Alimentation", subcategory: "Friandises", priceRange: "14,000DT", image: "img/product/jerky.jpg" },
//     { id: 19, name: "Jerky Time Sandwich", category: "Alimentation", subcategory: "Friandises", priceRange: "14,000DT", image: "img/product/sandwich.jpeg" },
//     { id: 20, name: "RECOMPENSE CARNILOVE CHIEN", category: "Alimentation", subcategory: "Friandises", priceRange: "14,000DT", image: "img/product/boie.jpg" },
//     { id: 21, name: "Truly Croissants", category: "Alimentation", subcategory: "Friandises", priceRange: "12,000DT", image: "img/product/truly.jpg" },
//     { id: 22, name: "Canne à pêche avec Matatabi", category: "Jouets", subcategory: "Jouets", priceRange: "12,000DT", image: "img/product/canne-matatabi.jpeg" },
//     { id: 23, name: "Canne avec souris", category: "Jouets", subcategory: "Jouets", priceRange: "12,000DT", image: "img/product/canne-souri.png" },
//     { id: 24, name: "Caramelle Sisal avec plumes", category: "Jouets", subcategory: "Jouets", priceRange: "9,000DT", image: "img/product/caramelle-sisal.jpg" }
//   ];

//   const filteredProducts = products.filter((product) =>
//     selectedType === "Chats"
//       ? product.name.toLowerCase().includes("chat")
//       : selectedType === "Chiens"
//         ? product.name.toLowerCase().includes("chien")
//         : selectedType === "Jouets"
//           ? product.category.toLowerCase().includes("jouets")
//           : false
//   );

//   return (
//     <section className="new-arrivals py-5">
//       <div className="container">
//         <div className="row justify-content-center">
//           <div className="col-xl-7 col-lg-9">
//             <div className="section-title text-center mb-65">
//               <div className="section-icon"><img src="img/icon/pawprint.png" alt="" /></div>
//               <h5 className="sub-title">New Arrivals</h5>
//               <h2 className="title">Découvrez nos nouveautés chez Animalia+</h2>
//               <p>Explorez les derniers produits ajoutés à notre boutique. Que ce soit pour chats, chiens ou pour le jeu, trouvez ce qu’il vous faut.</p>
//             </div>
//             <div
//   className="d-flex justify-content-center flex-wrap mb-4"
//   style={{ gap: "2rem" }}
// >
//   {categoriess.map((cat) => (
//     <button
//       key={cat}
//       onClick={() => handleCategoryClick(cat)}
//       className={`btn px-4 py-2 fs-5 ${selectedType === cat ? "selected-category" : "unselected-category"}`}
//       style={{
//         minWidth: "120px",
//         borderRadius: "18px",
//         fontWeight: "700",       // makes font bold
//         textAlign: "center",     // center text horizontally
//         display: "flex",         // use flexbox for better centering
//         justifyContent: "center",// center content horizontally
//         alignItems: "center"     // center content vertically
//       }}
//     >
//       {cat}
//     </button>
//   ))}
// </div>



//           </div>
//         </div>

//         <div className="row justify-content-center">
//           {filteredProducts.map((product) => (
//             <div className="col-lg-4 col-md-6" key={product.id}>
//               <div className="adoption-shop-item">
//                 <div className="adoption-shop-thumb" style={{ width: "100%", height: "200px", overflow: "hidden", borderRadius: "10px", marginBottom: "15px", position: "relative" }}>
//                   <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
//                     <img
//                       src={product.image}
//                       alt={product.name}
//                       style={{
//                         width: product.id === 3 ? "20%" : "50%",
//                         height: product.id === 3 ? "70%" : "90%",
//                         objectFit: "cover",
//                         display: "block"
//                       }}
//                     />
//                   </div>

//                   {promoIds.includes(product.id) && (
//                     <span className="badge bg-success position-absolute top-0 end-0 m-2">Promo!</span>
//                   )}

//                   <Link to={`/shop-details/${product.id}`} className="btn">
//                     Détails <img src="img/icon/w_pawprint.png" alt="" />
//                   </Link>
//                 </div>

//                 <div className="adoption-shop-content">
//                   <h4 className="title">
//                     <Link to={`/shop-details/${product.id}`}>{product.name}</Link>
//                   </h4>
//                   <div className="adoption-meta">
//                     <ul>
//                       <li><i className="fas fa-cog" /> {product.subcategory || "—"}</li>
//                       <li><i className="far fa-calendar-alt" /> Catégorie : {product.category}</li>
//                     </ul>
//                   </div>
//                   <div className="adoption-rating">
//                     <ul>
//                       <li className="price">Prix : <span>{product.priceRange || "—"}</span></li>
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}

//           {filteredProducts.length === 0 && selectedType !== "More" && (
//             <div className="col-12 text-center">
//               <p className="text-muted">Aucun produit trouvé.</p>
//             </div>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default NewArrivals;
import { useState, useEffect } from "react";
import {  Link } from "react-router-dom";
import { supabase } from "../lib/supabaseClient.ts";

const getImageUrl = (path) =>
  `https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/${path}`;

const NewArrivals = () => {
  const [selectedType, setSelectedType] = useState("Chats");
  const [isMobile, setIsMobile] = useState(false);

  const [arrivals, setArrivals] = useState([]);
  const [sectionMeta, setSectionMeta] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

useEffect(() => {
  const fetchArrivals = async () => {
    // Fetch section meta from arrivals_section table
    const { data: section, error: error1 } = await supabase
      .from("arrivals_section")
      .select("*")
      .maybeSingle();

    // Fetch only products where new = true
    const { data: products, error: error2 } = await supabase
      .from("products")
      .select("*")
      .eq("new", true);

    if (!error1 && section) setSectionMeta(section);
    if (!error2 && products) setArrivals(products);
  };

  fetchArrivals();
}, []);


  const promoIds = arrivals.filter((p) => p.is_promo).map((p) => p.id);

  const filteredProducts = arrivals
    .filter((product) => product.price_range && !product.price_range.includes("–"))
    .slice(0, 6);

  return (
 <section className="new-arrivals py-5">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-xl-7 col-lg-9">
        <div className="section-title text-center mb-65">
          <h5 className="sub-title" style={{ fontSize: isMobile ? "16px" : "18px" }}>
            {sectionMeta?.subtitle || "New Arrivals"}
          </h5>
          <h2
            className="title"
            style={{
              fontSize: isMobile ? "24px" : "34px",
              fontWeight: "700",
            }}
          >
            {sectionMeta?.title || "Découvrez nos nouveautés chez Animalia+"}
          </h2>
          <p
            style={{
              fontSize: isMobile ? "12px" : "14px",
              textAlign: "center",
              maxWidth: "500px",
              margin: "auto",
              lineHeight: "1.5",
            }}
          >
            {sectionMeta?.description ||
              "Explorez les derniers produits ajoutés à notre boutique. Que ce soit pour chats, chiens ou pour le jeu, trouvez ce qu’il vous faut."}
          </p>
        </div>
      </div>
    </div>

    {/* Card Wrapper */}
    <div
      className="scroll-container"
      style={{
        display: "flex",
        flexDirection: "row",
        overflowX: isMobile ? "auto" : "unset",
        overflowY: "hidden", // Prevent vertical scroll
        gap: isMobile ? "1rem" : "2.5rem",
        scrollSnapType: isMobile ? "x mandatory" : "none",
        padding: isMobile ? "0 16px" : "0",
        margin: isMobile ? "0" : "0 100px",
        flexWrap: isMobile ? "nowrap" : "wrap",
        justifyContent: isMobile ? "flex-start" : "center",

        // Hide scrollbar cross-browser
        scrollbarWidth: "none", // Firefox
        msOverflowStyle: "none", // IE 10+
      }}
    >
      {filteredProducts.map((product, index) => (
        <div
          key={product.id}
          className="adoption-shop-item"
          style={{
            scrollSnapAlign: isMobile ? "start" : "unset",
            flex: isMobile ? "0 0 72%" : "0 0 calc(33.33% - 2.5rem)",
            width: isMobile ? "auto" : "100%",
            backgroundColor: "#F4F1EA",
            borderRadius: "4px",
            padding: "10px",
            height: "303px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {/* Image */}
          <Link to={`/shop-details/${product.id}`}>
            <div
              className="adoption-shop-thumb"
              style={{
                width: "100%",
                height: "170px",
                overflow: "hidden",
                marginBottom: "8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
              }}
            >
              <img
                key={product.id}
                src={product.image}
                alt={product.name}
                style={{
                  width: product.id === 3 ? "60%" : "90%",
                  height: isMobile ? "100%" : "90%",
                  objectFit: "contain",
                  backgroundColor: "transparent",
                  transform: isMobile && index === 0 ? "translateX(10%)" : "none",
                }}
              />
              {promoIds.includes(product.id) && (
                <span className="badge bg-success position-absolute top-0 end-0 m-2">
                  Promo!
                </span>
              )}
            </div>
          </Link>

          {/* Text */}
          <div
            className="adoption-shop-content"
            style={{
              textAlign: "center",
              width: "90%",
              height: "50%",
              minHeight: "80px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              marginLeft: "15px",
              transform: "translateY(67px)",
            }}
          >
            <h6
              className="title"
              style={{
                fontSize: isMobile ? "14px" : "16px",
                marginBottom: "6px",
                color: "black",
                minHeight: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Link to={`/shop-details/${product.id}`}>{product.name}</Link>
            </h6>

            <div className="adoption-meta">
              <ul></ul>
            </div>

{product.price_range && (
  <div className="adoption-rating">
    <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
      <li
        className="price"
        style={{
          fontSize: "15px",
          color: "#ff41b4",
          fontWeight: "bold",
          textAlign: "right",
          transform: isMobile
            ? "translateX(35px)"
            : "translateX(45px)",
        }}
      >
        <span>
          {new Intl.NumberFormat("fr-FR", {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3,
          }).format(parseFloat(product.price_range))}{" "}
          DT
        </span>
      </li>
    </ul>
  </div>
)}


          </div>
        </div>
      ))}

      {filteredProducts.length === 0 && (
        <div className="col-12 text-center">
          <p className="text-muted">Aucun produit trouvé.</p>
        </div>
      )}
    </div>
  </div>
</section>

  );
};

export default NewArrivals;
